import { Component, HostBinding, input } from '@angular/core';

import { SingleField } from '../single-field.model';

@Component({
    selector: 'r1-compass-lib-field-filler',
    imports: [],
    template: ` <div class="filler"></div> `,
    styles: [
        `
            .filler {
                display: inline-block;
                width: 100%;
                vertical-align: middle;
            }
        `,
    ],
})
export class FieldFillerComponent implements SingleField {
    fieldWidth = input.required<number>();

    /*** Set in @see {@link FieldRowComponent} */
    @HostBinding('style.width') widthPer!: string;

    public setWidthPer(width: string) {
        this.widthPer = width;
    }
}
